<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card title="Импорт">
        <ImportList />

        <vs-collapse accordion>

          <vs-collapse-item v-if="$can('rp.devices', 'write')">
            <div slot="header">Приборы учета</div>
            <import-devices :selected-house-id="selectedHouseId" />
          </vs-collapse-item>

          <vs-collapse-item v-if="$can('rp.devices', 'write')">
            <div slot="header">Показания приборов учета</div>
            <import-values :selected-house-id="selectedHouseId" />
          </vs-collapse-item>

          <vs-collapse-item v-if="$can('rp.devices', 'write')">
            <div slot="header">Импорт показаний ХВС и ГВС</div>
            <import-water-apartments :selected-house-id="selectedHouseId" />
          </vs-collapse-item>

          <vs-collapse-item v-if="$can('rp.devices', 'write') && selectedMcsId === 15">
            <div slot="header">Импорт ЭЭ</div>
            <import-device345-apartments :selected-house-id="selectedHouseId" />
          </vs-collapse-item>

          <vs-collapse-item v-if="$can('rp.devices', 'write')">
            <div slot="header">Импорт ТЭ по теплораспределителям</div>
            <import-device2-apartments :selected-house-id="selectedHouseId" />
          </vs-collapse-item>

<!--          <vs-collapse-item v-if="$can('rp.apartments_import', 'write')">-->
<!--            <div slot="header">Помещения</div>-->
<!--            <import-apartments :selected-house-id="selectedHouseId" />-->
<!--          </vs-collapse-item>-->

          <!--          <vs-collapse-item v-if="$can('rp.apartments_import', 'write')">-->
          <!--            <div slot="header">Постоянно зарегистрированные</div>-->
          <!--            <import-apartment-users :selected-house-id="selectedHouseId" />-->
          <!--          </vs-collapse-item>-->

          <!--          <vs-collapse-item v-if="$can('rp.apartments_import', 'write')">-->
          <!--            <div slot="header">Временно зарегистрированные</div>-->
          <!--            <import-apartment-temp-users :selected-house-id="selectedHouseId" />-->
          <!--          </vs-collapse-item>-->

          <!--          <vs-collapse-item v-if="$can('rp.apartments_import', 'write') && 4643 === $store.getters['appUser/id']">-->
          <!--            <div slot="header">Полный импорт зарегистрированных</div>-->
          <!--            <import-apartment-full-users :selected-house-id="selectedHouseId" />-->
          <!--          </vs-collapse-item>-->

          <!--          <vs-collapse-item v-if="$can('rp.invoices', 'write')">-->
          <!--            <div slot="header">Импорт реестра Сбербанка</div>-->
          <!--            <import-reestr-sberbank-->
          <!--              :selected-house-id="selectedHouseId"-->
          <!--              @showInvoices="openInvoicesPopup"-->
          <!--            />-->
          <!--          </vs-collapse-item>-->

          <!--          <vs-collapse-item v-if="$can('rp.invoices', 'write')">-->
          <!--            <div slot="header">Импорт реестра ПЭС</div>-->
          <!--            <import-pes-->
          <!--              :selected-house-id="selectedHouseId"-->
          <!--              @showInvoices="openInvoicesPopup"-->
          <!--            />-->
          <!--          </vs-collapse-item>-->

          <!--          <vs-collapse-item v-if="$can('rp.invoices', 'write')">-->
          <!--            <div slot="header">Импорт реестра ПСКБ</div>-->
          <!--            <import-pscb-->
          <!--              :selected-house-id="selectedHouseId"-->
          <!--              @showInvoices="openInvoicesPopup"-->
          <!--            />-->
          <!--          </vs-collapse-item>-->

          <!--          <vs-collapse-item v-if="$can('rp.invoices', 'write')">-->
          <!--            <div slot="header">Импорт выписок</div>-->
          <!--            <import-statements-->
          <!--              :selected-house-id="selectedHouseId"-->
          <!--              @showInvoices="openInvoicesPopup"-->
          <!--            />-->
          <!--          </vs-collapse-item>-->
        </vs-collapse>
      </vx-card>
    </div>
    <ShowInvoicesPopup ref="invoicesPopup" />
  </div>
</template>

<script>

import ShowInvoicesPopup         from "@/components/calculated-program/import/ShowInvoicesPopup";
import ImportApartmentFullUsers  from "@/components/calculated-program/import/new/ImportApartmentFullUsers";
// import ImportApartments          from "@/components/calculated-program/import/new/ImportApartments";
import ImportApartmentTempUsers  from "@/components/calculated-program/import/new/ImportApartmentTempUsers";
import ImportApartmentUsers      from "@/components/calculated-program/import/new/ImportApartmentUsers";
import ImportDevice2Apartments   from "@/components/calculated-program/import/new/ImportDevice2Apartments";
import ImportDevice345Apartments from "@/components/calculated-program/import/new/ImportDevice345Apartments";
import ImportDevices             from "@/components/calculated-program/import/new/ImportDevices";
// import ImportPes                 from "@/components/calculated-program/import/new/ImportPes";
// import ImportPscb                from "@/components/calculated-program/import/new/ImportPscb";
// import ImportReestrSberbank      from "@/components/calculated-program/import/new/ImportReestrSberbank";
// import ImportStatements          from "@/components/calculated-program/import/new/ImportStatements";
import ImportValues              from "@/components/calculated-program/import/new/ImportValues";
import ImportWaterApartments     from "@/components/calculated-program/import/new/ImportWaterApartments";
import ImportList                from "@/components/calculated-program/import/ImportList";

export default {
  name:       "Import",
  components: {
    ImportList,
    // ImportStatements,
    // ImportPscb,
    // ImportPes,
    // ImportReestrSberbank,
    ImportApartmentFullUsers,
    ImportApartmentTempUsers,
    ImportApartmentUsers,
    // ImportApartments,
    ImportDevice2Apartments,
    ImportWaterApartments,
    ImportValues,
    ImportDevice345Apartments,
    ImportDevices,
    ShowInvoicesPopup,
  },
  computed:   {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
    selectedMcsId() {
      return this.$store.getters['appUser/selectedHouse'].management_companies_id;
    },
  },
  methods:    {
    openInvoicesPopup( invoices = [] ) {
      this.$refs.invoicesPopup.open(invoices);
    },
  },
};
</script>
